import _ from 'lodash-es';
import deepdash from 'deepdash-es';
deepdash(_);
import * as fflate from 'fflate';
import colorDialog from './htmlEngine/colorDialog';
import http from './http';

import * as funJSON from 'funjson/es/funJSON';

import * as echarts from '../vendor/echarts.esm.js';
import {executeFunction} from '../namedArgs.js';

import { cloneFunction, cloneWithFunctions, cloneDeepWithFunctions } from '../cloneFunction';
_.mixin({ cloneFunction });
_.mixin({ cloneWithFunctions });
_.mixin({ cloneDeepWithFunctions });
import requestQueue from './requestQueue';
import getDefaultStyle from './htmlEngine/css/defaultStyle';
import updateStyle from './htmlEngine/css/updateStyle';
import './htmlEngine/css/mui.css';
import './htmlEngine/css/dim.css';
import './htmlEngine/css/effect.css';
import {renderControls} from './htmlEngine/renderControls';
import layout from './tpl';

import debug from './debug';
import Spinner from './spinner';
import Minimap from './minimap';
import DropBoxComponent from './dropBoxComponent';
import Timeline from './timeline';
import uniqueId from './htmlEngine/uniqueId';
import updateClass from './htmlEngine/css/updateClass';
import scrollbarsStyle from './htmlEngine/css/scrollbarsStyle';
import { v4 as uuid4, v5 as uuid5 } from 'uuid';
import {
  list as listDropbox,
  download as downloadDropbox,
  upload as uploadDropbox,
  mput as mputDropbox,
  remove as deleteDropbox,
  getFileUrl as getFileUrlDropBox
} from './dropbox';


import {rescopeFunction} from '../rescopeFunction';

import fakeApi from './fakeApi';

import Events from '../events';
import AudioAPI from './audioApi';
import { RecorderAPI } from './recorderApi';
import TranscriberAPI from './transcriberApi';

const internalEvents = [
'beforeloaddata',
'loaddata',
'beforedestroy',
'destroy',
'beforereload',
'reload',
'reloadfailed',
'beforerefresh',
'refresh',
'refreshfailed',
'beforesetdata',
'setdata',
'beforeresize',
'resize',
'suspend',
'resume',
'ready',
'beforepreprocessoptions',
'beforecallableoption',
'callableoption',
'preprocessoptions',
'beforedatasource',
'datasource',
'faildatasource',
'beforerender',
'render',
'init',
'beforebinddomainvars',
'binddomainvars',
'beforebinddata',
'binddata',
'beforelinkdata',
'linkdata',
'beforelinkicons',
'linkicons',
'beforeRenderControls',
'renderControls'
];

export default function recharts(args) {
  window.funJSON = funJSON;
  window._ = _;
  window.updateStyle = updateStyle;
  if (args.expose) {
    if (args._) {
    }

    if (args.funJSON) {
      window.funJSON = funJSON;
    }

    if (args.updateStyle) {
    }

    if (args.debug) {
      window.debug = debug;
    }

    // if (args.echarts) {
    //   window.echarts = echarts;
    // }
    return;
  }

  const log = debug(`recharts:${args.name || args.cid}`);
  // console.log(`recharts:${args.name || args.cid}`);
  args.log = log;
  log('start, preparing args..');
  return prepareArgs(args)
    .then(function(args) {
      log('args prepared for loading options..');
      return loadChart(args);
    })
    .then(function(instance) {
      //if (instance.datasources.cache !== undefined) {
      instance.refresh();
      //}

      if (
        !instance.datasources.empty &&
        ( instance.datasources.autoload == undefined || instance.datasources.autoload)
      ) {
        log('options loaded, now data..');
        try {
          return reload(instance, args.datasourceParameters);
        } catch (err) {
          console.error('data load very failed, instance will be destroyed', err);
          instance.destroy();
          throw err;
        }
      } else {
        // console.log('Component initial data source fetch skipped due to datasource settings.');
        return Promise.resolve(instance);
      }
    })
    .catch(function(err) {
      // if(!instance||instance.destroyed){
      console.error(`Component "${args.name || args.cid}" start error`, err);
      throw new Error(err);
      // }
    });
}

function refresh(instance) {
  return render(instance);
}

function reload(instance, datasourceParameters, re) {
  instance._checkDestroy();
  instance.fire('beforeloaddata', datasourceParameters);
  instance.updateDatasourceParameters();
  datasourceParameters = !_.isEmpty(datasourceParameters)
    ? datasourceParameters
    : !_.isEmpty(instance.datasourceParameters)
    ? instance.datasourceParameters
    : {};
  instance.log('start');
  if (instance.destroyed) {
    instance.log('stop destroyed');
    instance.fire('loaddata', null);
    return Promise.resolve(instance);
  }

  if (re && !instance.autoreloadTimer) {
    instance.log('stop re-reload - no timer');
    instance.fire('loaddata', null);
    return Promise.resolve(instance);
  }

  if (re && instance.suspended) {
    instance.log('stop re-reload - suspended');
    instance.fire('loaddata', null);
    return Promise.resolve(instance);
  }

  if (!instance.datasources.empty) {
    if (instance.args.data) {
      instance.log('data loaded from args');
      instance.fire('loaddata', instance.args.data);
      return render(instance, instance.args.data);
    } else {
      if (
        instance.datasources &&
        instance.datasources.autoreload &&
        instance.datasources.autoreload.mode == 'polling' &&
        instance.args.designMode === undefined
      ) {
        if (!instance.autoreloadTimer) {
          instance.log('create timer for autoreload');
          instance.autoreloadTimer = window.setInterval(function() {
            if (!instance.autoreloadTimer) {
              instance.log('ignore autoreload - no timer');
              return;
            }

            if (instance.destroyed) {
              instance.log('ignore autorelaod - instance destroyed');
              return;
            }

            if (instance.suspended) {
              instance.log('ignore autoreload - suspended');
              return;
            }

            instance.log('autoreload by timer');
            reload(instance, undefined, true);
          }, instance.datasources.autoreload.period * 1000);
        }
      }

      instance.log('callDatasourceFunction enqueued');
      return requestQueue({
        getPromise: function() {
          return callDatasourceFunction(instance, datasourceParameters);
        },
        hash:
          instance.args.name + ':' + instance.args.cid + '-' + JSON.stringify(datasourceParameters),
        name: instance.args.name,
      }).then(function(data) {
        instance.fire('loaddata', data);
        //if (!re) {
        instance.log('reload got DS data - start render..', data);
        instance.data = data;
        return render(instance, data);
        //}

        // instance.log('reload got DS data - start update..');
        // return update(instance, data);
      });
    }
  } else {
    instance.log('no bindings found - skip data load - start render..');
    instance.fire('loaddata', null);
    return render(instance);
  }
}

function startPollingData(instance, datasourceParameters, callback, period, maxRepeat){
  
  if(!period){
    throw new Error('period parameter of startPollingData method cannot be empty or zero');
  } 

  const timer = setInterval(()=>{
    try{
      instance._checkDestroy();      
      if(instance.pollDataTimers[timer]){
        fetchData(instance,datasourceParameters).then(data=>{
          if(maxRepeat){maxRepeat--;}

          if(callback(data, instance.pollDataTimers[timer]++)===false||maxRepeat===0||instance.destroyed){
            clearInterval(timer);
            delete instance.pollDataTimers[timer];
          }      
        });      
      }
    }catch(ex){
      clearInterval(timer);
      delete instance.pollDataTimers[timer];
      throw ex;
    }
  },period);
  instance.pollDataTimers[timer] = 1;
  return timer;
}

function stopPollingData(instance, timer){
  if(instance.pollDataTimers[timer]){
    clearInterval(timer);
    delete instance.pollDataTimers[timer];    
  }
}

function fetchData(instance, datasourceParameters) {
  instance._checkDestroy();
  if (instance.destroyed) {
    return Promise.resolve();
  }

  instance.updateDatasourceParameters();
  datasourceParameters = !_.isEmpty(datasourceParameters)
    ? datasourceParameters
    : !_.isEmpty(instance.datasourceParameters)
    ? instance.datasourceParameters
    : {};

  if (instance.datasources.empty) {
    if (instance.args.data) {
      return instance.args.data;
    } else {
      return requestQueue({
        getPromise: function() {
          return callDatasourceFunction(instance, datasourceParameters);
        },
        hash:
          instance.args.name + ':' + instance.args.cid + '-' + JSON.stringify(datasourceParameters),
        name: instance.args.name,
      });
    }
  } else {
    throw new Error('Datasource not specified.');
  }
}
function _fetchDataFromServer(instance, datasourceParameters) {
  instance._checkDestroy();
  if (instance.destroyed) {
    return Promise.resolve();
  }

  instance.updateDatasourceParameters();
  datasourceParameters = !_.isEmpty(datasourceParameters)
    ? datasourceParameters
    : !_.isEmpty(instance.datasourceParameters)
    ? instance.datasourceParameters
    : {};

  return requestQueue({
    getPromise: function() {
      return callDatasourceFunction(instance, datasourceParameters);
    },
    hash:
      instance.args.name + ':' + instance.args.cid + '-' + JSON.stringify(datasourceParameters),
    name: instance.args.name,
  });
    
}

function prepareArgs(args) {
  if (!args) {
    return Promise.reject('Cannot init chart, args are empty');
  }

  if (!args.cid) {
    return Promise.reject('Cannot init chart, args.cid is empty');
  }

  args.fullCid = args.cid;

  if (args.parentCid) {
    args.fullCid += ':' + args.parentCid;
  }

  if (!args.token && !args.auth) {
    return Promise.reject('Cannot init chart, args.token and args.auth both are empty');
  }

  if (!args.token) {
    args.token = 'xxx';
  }

  if (!args.element) {
    return Promise.reject('Cannot init chart, args.element is empty');
  }

  if (!args.url) {
    args.url = location.protocol + '//' + location.host;
  }

  if (!args.delay) {
    args.delay = 0;
  }

  if(!args.datasource){
    args.datasource={empty:true};
  }else if(!args.datasource.function){
    args.datasource.empty = true;
  }

  args.isLayoutMode =
    args.designMode == 'layout' ||
    args.designMode == 'io-layout' ||
    args.designMode == 'overlay-layout';

  args.isDesignMode =
    args.designMode == 'design' ||
    args.designMode == 'io-design' ||
    args.designMode == 'overlay-design';

  if(!args.app) {args.app = fakeApi({},'This is a Delegate Method and will only take action when the component is deployed as part of a Published Application.');}

  return Promise.resolve(args);
}

function createInstance(args, options, datasources) {
  _.each(options.series, (serie) => {
    if (serie.type == 'singlevalue' || serie.type == 'multisinglevalue') {
      if (!_.isArray(serie.data)) {
        serie.data = [serie.data];
      }
    }
  });

  for (var i = 0; options.series && i < options.series.length; i++) {
    var serie = options.series[i];
    serie.actualType = serie.type;
    serie.type = serie.originalType || serie.type;
  }

  if (options && options.series) {
    let htmlSeries = _.remove(options.series, function(s) {
      return s.type == 'ticker';
    });
    if (htmlSeries.length) {
      if (!options.controls) {
        options.controls = [];
      }

      options.controls = options.controls.concat(htmlSeries);
    }
  }

  if(options.contextMenu){
      options.contextMenu.type='contextMenu';
      options.controls.push(options.contextMenu);
    }

    _.each(options.series, function(serie,i) {
      if(serie.contextMenu){
        serie.contextMenu.serieIndex = i;
        options.controls.push(serie.contextMenu);
      }
    });

  const bindings = [];
  let hasExtBinding = false;
  const links = {};


  _.eachDeep(
    options,
    function(value, key, parent, context) {
      let path = context.path || '';

      if (value === undefined) {
        args.log('undefined @' + path, options);
      }

      if (_.isArray(value) && value[0] && value[0].type == 'binding') {
        bindings.push(_.replace(path, '[*]', ''));
        hasExtBinding = hasExtBinding || !!value[0].extType;
        return false;
      }

      if (_.isObject(value) && value.binding && value.binding.type === 'binding') {
        bindings.push(path);
        hasExtBinding = hasExtBinding || !!value.binding.extType;
      }

      if (_.isObject(value) && value.binding && value.binding.type === 'variableLink') {
        links[path] = {
          ...value.binding,
          staticValue: value.staticValue,
          meta: { value, key, parent, context },
          // action:value.action
        };
      }
    },
    { includeRoot: false }
  );
  const events = _.reduceDeep(
    options,
    (res, ev, k, p, c) => {
      if (c.parent && c.parent.key == 'events') {
        ev = _.cloneDeep(ev);
        ev.eventPath = c.path;
        res.push(ev);
      }

      return res;
    },
    []
  );
  const publicEvents = _(events)
    .filter((ev) => ev.public !== false)
    .map((e) => e.name || e.type)
    .value();
  args.element.classList.add('recharts-default');
  let [innerEl] = args.element.getElementsByClassName('inner');
  if (!innerEl) {
    innerEl = document.createElement('DIV');
    innerEl.classList.add('inner');

    innerEl.style.position = 'absolute';
    innerEl.style.top = '0px';
    innerEl.style.right = '0px';
    innerEl.style.bottom = '0px';
    innerEl.style.left = '0px';
    args.element.appendChild(innerEl);
  }

  updateClass('recharts-default-style', scrollbarsStyle(), '.recharts-default');

  var instance = {
    frozenOptions:[],
    radioGroups:{},
    calloutGroups:{},
    innerEl,
    destroyed: false,
    args,
    log: args.log,
    name: args.name,
    originalOptions: options,
    datasources,
    bindings,
    hasExtBinding,
    links,
    events,
    publicEvents,
    chart: echarts.init(innerEl),
    suspended: false,
    extData:{},
    pollDataTimers:{},
    app: args.app,    
    timer:{
      _config:_.defaults(options.timer,{
        autostart: 'off',
        interval: 5000,
        delay:0
      }),
      _id:null,
      _delay_id:null,
      isStarted(){
        return this._id!==null;
      },
      start(withDelay=true){
        if(instance.destroyed || this.isStarted()){
          return;
        }
        
        var execTrigger = instance.getOption('triggers.timerTriggers.execute');
        if(!execTrigger){
          throw new Error('Cannot start timer, "execute" timer trigger is not defined.');
        }

        var failTrigger = instance.getOption('triggers.timerTriggers.fail');

        const run = ()=>{
          if(!this.isStarted()){
            return;
          }

          if(instance.destroyed){
            return this.stop();
          }

          const _timerCompName = (instance.options && instance.options.chartName) || instance.args.name || '';
          const _timerCompCid = instance.args.cid || '';
          const _timerCompLabel = _timerCompName ? (_timerCompCid ? `${_timerCompName} [${_timerCompCid}]` : _timerCompName) : _timerCompCid;
          let res;
          try{
            try{
              res = execTrigger('execute',instance);
            }catch(ex){
              console.error(`[timerTrigger] "execute" failed in component "${_timerCompLabel}": `, ex);
              throw ex;
            }

            if(res && res.then){
              this.stop();
              res.then((result)=>{
                var completeTrigger = instance.getOption('triggers.timerTriggers.complete');
                if(completeTrigger){
                    try{
                      completeTrigger(event,instance,result);
                    }catch(ex){
                      console.error(`[timerTrigger] "complete" failed in component "${_timerCompLabel}": `, ex);
                      throw ex;
                    }
                }

                setTimeout(()=>this.start(false),0);

              }).catch((ex)=>{
                if(failTrigger){
                  try{
                    failTrigger('fail',instance,ex);
                  }catch(ex){
                    console.error(`[timerTrigger] "fail" failed in component "${_timerCompLabel}": `, ex);
                  }
                }else{
                  console.error(ex);
                }
              });
            }
          }catch(ex){
            this.stop();
            if(failTrigger){
              try{
                failTrigger('fail',instance,ex);
              }catch(ex){
                console.error(`[timerTrigger] "fail" failed in component "${_timerCompLabel}": `, ex);
              }
            }else{
              console.error(ex);
            }
          }
        };

        this._id = true;
        this._delay_id = setTimeout(()=>{
          if(instance.destroyed || !this.isStarted()){
            return;
          }

          this._delay_id=null;
          this._id = setInterval(run,this._config.interval);
        },withDelay&&this._config.delay||0);

      },
      stop(){
        if(this._delay_id){
          clearTimeout(this._delay_id);
          this._delay_id = null;
        }

        if(this._id && this._id!==true){
          clearInterval(this._id);
          this._id = null;
        }
      }
    },

    // freezeOptions(path){
    //   if(!this.frozenOptions.includes(path)){
    //     this.frozenOptions.push(path);
    //   }
    // },

    // unFreezeOptions(path){
    //   this.frozenOptions = this.frozenOptions.filter(f=>f!==path);
    // },

    // unFreezeAllOptions(){
    //   this.frozenOptions = [];
    // },

    getGroupSelectedValue(group){
      
      if(!this.radioGroups[group]) { throw new Error(`Group "${group}" not found.`);}

      const checked = _.find(this.radioGroups[group], r => r.isChecked);
      return checked && checked.value;
    },

    getGroupSelectedName(group){
      
      if(!this.radioGroups[group]) { throw new Error(`Group "${group}" not found.`);}

      const checked = _.find(this.radioGroups[group], r => r.isChecked);
      return checked && checked.name;
    },

    setGroupSelectedValue(group, value, render=true){
      
      if(!this.radioGroups[group]) { throw new Error(`Group "${group}" not found.`);}

      let done = false;
      _.each(this.radioGroups[group], r => {        
        r.isChecked = !done && r.value===value;
        if(r.value==value){ done = true }

        if(render) {r.render();}
      });

      if(value!==null && value!==undefined && !done) { throw new Error(`Value "${value}" not found in the group "${group}".`);}
      
    },

    setGroupSelectedName(group, name, render=true){
      
      if(!this.radioGroups[group]) { throw new Error(`Group "${group}" not found.`);}

      let done = false;
      _.each(this.radioGroups[group], r => {        
        r.isChecked = !done && r.name===name;
        if(r.name==name){ done = true }

        if(render) {r.render();}
      });
      
      if(name!==null && name!==undefined && !done) { throw new Error(`Name "${name}" not found in the group "${group}".`);}
    },

    getRect() {
      return { width: innerEl.clientWidth, height: innerEl.clientHeight };
    },

    getOption(path, defaultValue) {
      let res = _.get(instance._patchOptions, path);
      if (res === undefined) {
        res = _.get(instance.options, path);
      }

      if (res === undefined) {
        res = _.get(instance.originalOptions, path);
      }

      if (res === undefined) {
        res = defaultValue;
      }

      return res;
    },

    hasOption(path) {
      return (
        _.has(instance._patchOptions, path) ||
        _.has(instance.options, path) ||
        _.has(instance.originalOptions, path)
      );
    },

    setOption(path, value) {
      _.set(instance._patchOptions, path, value);
      if (
        instance.options.vars &&
        instance.options.vars._persistent &&
        instance.options.vars._persistent.includes(path)
      ) {
        const key = 'recharts.persistent.' + instance.args.cid + ':' + path;
        localStorage.setItem(key, funJSON.stringify(value));
      }
    },

    setOptions(value) {
      _.merge(instance._patchOptions, value);
      if (value.vars && instance.options.vars && instance.options.vars._persistent) {
        _.eachDeep(value.vars, (v, k, p, x) => {
          const path = 'vars.' + x.path;
          if (instance.options.vars._persistent.includes(path)) {
            const key = 'recharts.persistent.' + instance.args.cid + ':' + path;
            localStorage.setItem(key, funJSON.stringify(v));
          }
        });
      }
    },

    resetOptions() {
      instance._patchOptions = {};
      if (
        instance.options.vars &&
        instance.options.vars._persistent &&
        instance.options.vars._persistent.length
      ) {
        _.each(instance.options.vars._persistent, (path) => {
          const key = 'recharts.persistent.' + instance.args.cid + ':' + path;
          localStorage.removeItem(key);
        });
      }
    },

    resetControls(controlNames) {
      _.each(instance.controls, function(control) {
        if (!Array.isArray(controlNames) || controlNames.includes(control._controlOptions.name)) {
          control.reset();
        }
      });
      this.refresh();
    },

    getVariable(path, defaultValue) {
      const res = instance.getOption('vars.' + path, defaultValue);
      if (res === undefined && !instance.hasOption('vars.' + path)) {
        throw new Error(`Variable not found at ${path}. (Check spelling?)`);
      }

      return res;
    },

    setVariable(path, value) {
      if (!instance.hasOption('vars.' + path)) {
        throw new Error(`Variable not found at ${path}. (Check spelling?)`);
      }

      instance.setOption('vars.' + path, value);

      // Auto-sync: propagate into the live options tree so reads see the
      // new value, then re-link + re-render only the controls bound to
      // this variable. Avoids the full-canvas redraw that component.render()
      // would cause (which has the side effects the user has been working
      // around). Variables in binding paths / formulas remain as documented
      // edge cases — the caller can fall back to component.render() if
      // those derived values need to recompute.
      _.set(instance.options, 'vars.' + path, value);
      syncVariable(instance, path);
      instance.fire('variableChanged', { name: path, value });
    },

    setVariables(value) {
      instance.setOptions({ vars: value });

      // Bulk auto-sync. The setOptions call above wrote to _patchOptions
      // only; mirror each entry into the live options tree and union the
      // affected control sets so a control bound to multiple variables in
      // the batch renders once, not once per variable.
      if (value && typeof value === 'object') {
        const keys = Object.keys(value).filter(k => k !== '_persistent');
        keys.forEach(k => { _.set(instance.options, 'vars.' + k, value[k]); });
        const byVar = getLinksByVar(instance);
        const ctrls = new Set();
        const allAffectedPaths = [];
        keys.forEach(k => {
          const paths = byVar[k] || [];
          allAffectedPaths.push.apply(allAffectedPaths, paths);
        });

        const deferred = [];
        allAffectedPaths.forEach(optPath => {
          const link = instance.links[optPath];
          if (link) { linkOneVariable(optPath, link, instance.options, instance, deferred); }
        });
        deferred.forEach(f => { try { f(); } catch (e) { console.warn('deferred variable link failed', e); } });

        allAffectedPaths.forEach(optPath => {
          const ctrlPath = findEnclosingControlPath(optPath, instance);
          if (ctrlPath) { ctrls.add(ctrlPath); }
        });
        ctrls.forEach(p => {
          try { instance.controls[p].render(); }
          catch (e) { console.warn('Failed to re-render control after setVariables', p, e); }
        });

        keys.forEach(k => instance.fire('variableChanged', { name: k, value: value[k] }));
      }
    },

    resetVariables() {
      instance._patchOptions.vars = {};
      if (
        instance.options.vars &&
        instance.options.vars._persistent &&
        instance.options.vars._persistent.length
      ) {
        _.each(instance.options.vars._persistent, (p) => {
          const key = 'recharts.persistent.' + instance.args.cid + ':' + p;
          localStorage.removeItem(key);
        });
      }
    },

    get patchOptions() {
      if (instance.options && !instance._persistentVarsLoaded) {
        instance._persistentVarsLoaded = true;

        if (instance.options.vars) {
          _.each(instance.options.vars._persistent, (path) => {
            const key = 'recharts.persistent.' + instance.args.cid + ':' + path;
            let p = localStorage.getItem(key);
            if (p !== null) {
              // const o = _.get(instance.options, path);
              // if (_.isBoolean(o)) {
              //   p = p == 'true';
              // } else if (_.isNumber(o)) {
              //   p = Number(p);
              // }

              instance.setOption(path, funJSON.parse(p));
            }
          });
          // const p = localStorage.getItem('recharts.persistent.'+instance.args.cid);
          // if()
        }
      }

      return instance._patchOptions;
    },
    set patchOptions(patch) {
      instance.resetOptions();
      instance.setOptions(patch);
    },
    _patchOptions: {},
    // get handlers() {
    //   return instance.triggers;
    // },
    // triggers: {},
    controls: {},
    getControl(name) {
      return _.find(instance.controls, (c) => c.options && c.options.name == name);
    },
    // Returns the runtime instance of the IO toolbar — the slide-out panel
    // configured at `options.controls[0]`. (optionsStore.js merges the
    // separate `iocontrols.controls` section back into `options.controls`
    // before the rechart instance sees it, so the runtime location is
    // `options.controls[0]`, NOT `options.iocontrols.controls[0]`.)
    //
    // Resolution: try identity on `options.controls[0]` first; fall back to
    // a type=='toolbar' scan across `instance.controls` since toolbars don't
    // require an explicit `name`. Returns null if no toolbar is present.
    getIOControl() {
      const ioOpts = instance.options.controls && instance.options.controls[0];
      if (ioOpts && (ioOpts.type === 'toolbar' || ioOpts.type === 'toolbarPlaceholder')) {
        const byIdentity = _.find(instance.controls, (c) => c &&
          (c._controlOptions === ioOpts || c.options === ioOpts));
        if (byIdentity) { return byIdentity; }
      }

      return _.find(instance.controls, (c) =>
        c && (c.type === 'toolbar' ||
              (c._controlOptions && c._controlOptions.type === 'toolbar') ||
              (c.options && c.options.type === 'toolbar'))) || null;
    },
    getIcon(name) {
      const icon = _.find(instance.options.icons, { name });
      return icon && icon.url;
    },

    datasourceParameters: {},
    updateDatasourceParameters: () => {
      instance.datasourceParameters = {};
      if (instance.options.bindings) {
        _.each(instance.options.bindings.parameters, (param, path) => {
          instance.datasourceParameters[param.name] = instance.getOption(path);
        });
      }

      _.each(instance.controls, (c) => {
        c.updateDataSourceParameter();
      });
    },

    _checkDestroy: function() {
      if (!instance.suspended && !document.body.contains(instance.innerEl)) {
        instance.destroy();
      }
    },
    destroy: function() {
      var me = this;
      if(instance.destroyed){
        return Promise.resolve();
      }

      me.log('destroy start');
      instance.fire('beforedestroy');
      var res = new Promise(function(resolve) {
        instance.destroyed = true;
        if (instance.autoreloadTimer) {
          window.clearInterval(instance.autoreloadTimer);
          delete instance.autoreloadTimer;
        }

        if (instance.chart) {
          instance.chart.dispose();
          instance.args.element.innerHTML = '';
        }

        _.defer(function() {
          me.log('destroy end');
          resolve();
        });
      });
      res.then(function() {
        instance.fire('destroy');
      });
      return res;
    },

    recreateInstance(){
      return instance.destroy().then(()=>{
        return createInstance(instance.args, instance.originalOptions.$src, instance.datasources);        
      });
    },

    _logRender: function(label){
      if(!instance._logRenderCounter){
        instance._logRenderCounter={};
      }

      if(!instance._logRenderCounter[label]){
        instance._logRenderCounter[label]=0;
      }

      instance._logRenderCounter[label]+=1;
      label = `${label}(${instance._logRenderCounter[label]})::${instance.args.name}`;
      if(options.renderCanvas&&options.renderCanvas!='always'){
        console.log(`${label} - suspendCanvasRendering = ${instance.suspendCanvasRendering }`);
      }

      if(options.renderControls&&options.renderControls!='always'){
        console.log(`${label} - suspendControlsRendering = ${instance.suspendCanvasRendering }`);
      }
    },
    reload: function(datasourceParameters) {
      instance.fire('beforereload', datasourceParameters);
      var res = reload(instance, datasourceParameters);
      res
        .then(function() {
          instance.fire('reload', datasourceParameters);
        })
        ['catch'](function() {
          instance.fire('reloadfailed', datasourceParameters);
        });
      return res;
    },
    startPollingData: function(datasourceParameters, callback, period, max){      
      return startPollingData(instance, datasourceParameters, callback, period, max)
    },
    stopPollingData: function(timer){
      stopPollingData(instance,timer);
    },
    fetchData: function(datasourceParameters) {
      return fetchData(instance, datasourceParameters);
    },
    _fetchDataFromServer: function(datasourceParameters) {
      return _fetchDataFromServer(instance, datasourceParameters);
    },
    refresh: function() {
      instance.fire('beforerefresh');
      var res = refresh(instance);
      res
        .then(function() {
          instance.fire('refresh');
        })
        ['catch'](function(ex) {
          instance.fire('refreshfailed', ex);
        });
      return res;
    },
    render: function(){
      instance.refresh();
    },
    // setHtmlData: function(data, chartName) {
    //   if (instance.destroyed) {
    //     return;
    //   }

    //   var index = 0;
    //   var opt;
    //   opt = instance.chart.getOption();
    //   index = _.findIndex(opt.controls, { name: 'chartName', type: 'ticker' });
    //   if (index == -1) {
    //     throw new Error("Chart '" + chartName + "' not found");
    //   }

    //   opt = { controls: [] };
    //   for (var i = 0; i < index; i++) {
    //     opt.controls.push({});
    //   }

    //   opt.controls.push({ data: data });
    //   instance.fire('beforesetdata', index, data, chartName, 'controls');
    //   instance.chart.setOption(opt);
    //   instance.fire('setdata', index, data, chartName, 'controls');
    // },

    isDataOffline: function(nameOrIndex) {
      return instance.getData(nameOrIndex)!==undefined;     
    },
    resetData(nameOrIndex){
      instance.setData(undefined,nameOrIndex);
    },

    setData(data,nameOrIndex=0){
      if (instance.destroyed) {
        return;
      }

      if(_.isString(nameOrIndex)){
        nameOrIndex = _.findIndex(instance.options.series, {name:nameOrIndex});
        if(nameOrIndex == -1){
          nameOrIndex=0;
        }
      }

      instance.fire('beforesetdata', nameOrIndex, data);
      instance.setOption(['series',nameOrIndex,'data'],data);
      instance.fire('setdata', nameOrIndex, data);

    },

    getData(nameOrIndex=0){
      if (instance.destroyed) {
        return;
      }

      if(_.isString(nameOrIndex)){
        nameOrIndex = _.findIndex(instance.options.series, {name:nameOrIndex});
        if(nameOrIndex == -1){
          nameOrIndex=0;
        }
      }

      return instance.getOption(['series',nameOrIndex,'data']);

    },

    // Returns the raw backend payload currently cached on the instance —
    // the same object you'd get from getDataSource().getResults(false) or
    // getDataSource().getData(). Synchronous; returns undefined if no data
    // has been loaded yet. This is the "result matrix" bound to the canvas.
    getResultObject() {
      if (instance.destroyed) {
        return;
      }

      return instance.data;
    },

    getDataSource() {
      if (instance.destroyed) {
        return null;
      }

      return {
        // Get the datasource configuration
        getConfig() {
          return instance.datasources;
        },

        // Get the last loaded data from datasource
        // If refetch=true, fetches fresh data from server and returns Promise
        // If refetch=false (default), returns cached data synchronously
        getResults(refetch = false) {
          if (refetch) {
            // Fetch fresh data from datasource
            return instance._fetchDataFromServer();
          } else {
            // Return cached data
            return instance.data;
          }
        },

        // Check if datasource is empty (no function configured)
        isEmpty() {
          return instance.datasources.empty === true;
        },

        // Check if autoload is enabled
        isAutoload() {
          return instance.datasources.autoload !== false;
        },

        // Get autoreload configuration
        getAutoreload() {
          return instance.datasources.autoreload;
        },

        // Check if autoreload is enabled
        isAutoreloadEnabled() {
          return instance.datasources.autoreload !== undefined &&
                 instance.datasources.autoreload.mode === 'polling';
        },

        // Get cached data (if exists)
        getCache() {
          return instance.datasources.cache;
        },

        // Check if cache exists
        hasCache() {
          return instance.datasources.cache !== undefined;
        },

        // Get datasource function configuration
        getFunction() {
          return instance.datasources.function;
        },

        // Get node name
        getNode() {
          return instance.datasources.node;
        },

        // Get dataspace name
        getDataspace() {
          return instance.datasources.dataspace;
        },

        // Get current datasource parameters
        getParameters() {
          return instance.datasourceParameters;
        },

        // Get data - same as component.data
        getData() {
          return instance.data;
        }
      };
    },

    // setData: function(data, chartName) {
    //   if (instance.destroyed) {
    //     return;
    //   }

    //   var index = 0;
    //   var opt;
    //   if (chartName !== undefined) {
    //     opt = instance.chart.getOption();
    //     index = _.findIndex(opt.series, ['name', chartName]);
    //     if (index == -1) {
    //       return this.setHtmlData(data, chartName);
    //     }
    //   }

    //   opt = { series: [] };
    //   for (var i = 0; i < index; i++) {
    //     opt.series.push({});
    //   }

    //   opt.series.push({ data: data });
    //   instance.fire('beforesetdata', index, data, chartName, 'series');
    //   instance.chart.setOption(opt);
    //   instance.fire('setdata', index, data, chartName, 'series');
    // },
    resize: function() {
      if (instance.destroyed) {
        return;
      }

      let box = { top: '0', right: '0', bottom: '0', left: '0' };
      instance.fire('beforeresize');
      if (
        instance.originalOptions &&
        instance.originalOptions.aspectRatio &&
        instance.originalOptions.aspectRatio !== 'none'
      ) {
        let [rw, rh] = instance.originalOptions.aspectRatio.split(':');
        let rr = rw / rh;
        var w = instance.args.element.offsetWidth;
        var h = instance.args.element.offsetHeight;
        // let r = w / h;
        // w/h == rw/rh == rr
        // w == h*rr
        // h == w/rr
        let px = w - h * rr;
        // px>0 --> container too long
        // px<0 --> container too short
        let py = h - w / rr;
        // pt>0 --> container too high
        // pt<0 --> container too low
        if (!instance.originalOptions.fitStrategy) {
          instance.originalOptions.fitStrategy = 'contain';
        }

        if (instance.originalOptions.fitStrategy == 'contain') {
          if (px > 0) {
            box = {
              top: '0',
              right: px / 2,
              bottom: '0',
              left: px / 2,
            };
          } else if (py > 0) {
            box = {
              top: py / 2,
              right: '0',
              bottom: py / 2,
              left: '0',
            };
          }
        } else {
          instance.args.element.style.overflow = 'hidden';
        }

        if (instance.originalOptions.fitStrategy == 'cover') {
          if (px > 0) {
            box = {
              top: -px / 2,
              right: '0',
              bottom: -px / 2,
              left: '0',
            };
          } else if (py > 0) {
            box = {
              top: '0',
              right: -py / 2,
              bottom: '0',
              left: -py / 2,
            };
          }
        }

        if (instance.originalOptions.fitStrategy == 'width') {
          if (px > 0) {
            box = {
              top: -px / 2,
              right: '0',
              bottom: -px / 2,
              left: '0',
            };
          } else if (py > 0) {
            box = {
              top: py / 2,
              right: '0',
              bottom: py / 2,
              left: '0',
            };
          }
        }

        if (instance.originalOptions.fitStrategy == 'height') {
          if (px > 0) {
            box = {
              top: '0',
              right: px / 2,
              bottom: '0',
              left: px / 2,
            };
          } else if (py > 0) {
            box = {
              top: '0',
              right: -py / 2,
              bottom: '0',
              left: -py / 2,
            };
          }
        }
      }

      if (
        instance.originalOptions.controls &&
        instance.originalOptions.controls[0] &&
        instance.originalOptions.controls[0].ioEnabled
      ) {
        const tbOptions = instance.originalOptions.controls[0];
        if ((tbOptions.show == undefined || tbOptions.show) && tbOptions.state == 'static') {
          const position = tbOptions.position || 'top';
          let offset = _.get(tbOptions, 'style.size', '64');
          offset = offset.replace(/px$/, '');
          offset -= box[position];
          if (offset < 0) {
            offset = 0;
          }

          box[position] += offset;
        }
      }

      //console.log({ box }, instance);

      instance.innerEl.style.top = box.top + 'px';
      instance.innerEl.style.right = box.right + 'px';
      instance.innerEl.style.bottom = box.bottom + 'px';
      instance.innerEl.style.left = box.left + 'px';

      _.delay(function() {
        try {
          instance.chart.resize({
            silent: true,
            animation: { duration: 300, easing: 'cubicInOut' },
          });
        } catch (ex) {
          console.error(ex);
        }

        _.delay(function() {
          try {
            instance.chart.resize({
              silent: true,
              animation: { duration: 300, easing: 'cubicInOut' },
            });
          } catch (ex) {
            console.error(ex);
          }

          instance.fire('resize');
        }, 300);
      }, 300);
    },
    // getData: function(chartName) {
    //   if (instance.destroyed) {
    //     return;
    //   }

    //   var index = 0;
    //   var opt = instance.chart.getOption();
    //   if (chartName !== undefined) {
    //     index = _.findIndex(opt.series, ['name', chartName]);
    //     if (index == -1) {
    //       throw new Error("Chart '" + chartName + "' not found");
    //     }
    //   }

    //   return opt.series[index].data;
    // },
    suspend: function() {
      this.suspended = true;
      instance.fire('suspend');
    },
    resume: function() {
      this.suspended = false;
      if (instance.suspendedRender) {
        instance.suspendedRender().then(() => instance.fire('resume'));
      } else {
        instance.fire('resume');
      }
    },
    disable: function(options) {
      return toggleEnabled(instance, false, options);
    },
    enable: function() {
      return toggleEnabled(instance, true);
    },
    blurCanvas: function(blur) {
      this._blur = blur;
      this._updateDim();
    },
    greyscaleCanvas: function(greyscale) {
      this._greyscale = greyscale;
      this._updateDim();
    },
    maskCanvas: function(masked) {
      this._masked = masked;
      this._updateDim();
    },
    _updateDim: function() {
      if (this._blur && this._greyscale) {
        this.innerEl.classList.add('dim-fast');
        this.innerEl.classList.remove('bw-fast');
        this.innerEl.classList.remove('blur-fast');
      } else if (this._blur) {
        this.innerEl.classList.add('blur-fast');
        this.innerEl.classList.remove('dim-fast');
        this.innerEl.classList.remove('bw-fast');
      } else if (this._greyscale) {
        this.innerEl.classList.add('bw-fast');
        this.innerEl.classList.remove('dim-fast');
        this.innerEl.classList.remove('blur-fast');
      } else {
        this.innerEl.classList.remove('bw-fast');
        this.innerEl.classList.remove('dim-fast');
        this.innerEl.classList.remove('blur-fast');
      }

      if(this._masked){
        this.innerEl.classList.add('masked');
      }else{
        this.innerEl.classList.remove('masked');
      }
    },
    get id() {
      let id = instance.args.element.id;
      if (!id) {
        id = uniqueId(
          instance.args.element,
          'recharts-instance-' + (instance.args.name || '') + (instance.args.cid || '')
        );
      }

      return id;
    },
    set id(id) {
      instance.args.element.id = id;
    },
    setExtData(type,name,data){
      if(!this.extData[type]){
        this.extData[type] ={};
      }

      this.extData[type][name] = data;
      // delete this.boundOptions;      
    },
    dropBoxUpload(path, file, onProgress){
      return dropBoxUpload(instance.args,path,file,onProgress);
    },
    dropBoxMput(path, file, codec, partId, close, onProgress){
      return dropBoxMput(instance.args,path,file,codec, partId, close, onProgress);
    },
    dropBoxDownload({path,name}){
      return dropBoxDownload(instance.args,path,name);
    },
    dropBoxGetFileUrl({path,name}){
      return dropBoxGetFileUrl(instance.args,path,name);
    },
    dropBoxDelete({path,name}){
      return dropBoxDelete(instance.args,path,name);
    },
    dropBoxList(path){
      return requestQueue({
        getPromise: function() {
          return dropBoxList(instance.args,path);
        },
        hash:
          instance.args.name + ':' + instance.args.cid + '-' + JSON.stringify(path),
        name: instance.args.name,
      });      
    }    
  };
  instance._events = new Events(instance,{internalEvents});
  instance.once('destroy', ()=>instance._events.destroy());
  instance.once('init', ()=>{
    instance._inited = true;
    if(options.renderCanvas=='once'){
      instance.suspendCanvasRendering = true;
    }
    
    if(options.renderControls=='once'){
      instance.suspendControlsRendering = true;
    }
  });

  if (options.triggers && options.triggers.componentTriggers) {
    _.each(options.triggers.componentTriggers, (trigger, event) => {
      const scope = {
        component:instance,
        app:instance.app,
        chart:instance.chart,
        dataSource:instance.getDataSource(),
      };
      Object.defineProperty(scope, 'data', {
        get() { return instance.data; },
        enumerable: true
      });
      Object.defineProperty(scope, 'fn', {
        get() { return instance.fn; },
        enumerable: true
      });
      const _scopedTrigger = rescopeFunction(trigger, scope, instance);
      const _compName = (instance.options && instance.options.chartName) || instance.args.name || '';
      const _compCid = instance.args.cid || '';
      const _compLabel = _compName ? (_compCid ? `${_compName} [${_compCid}]` : _compName) : _compCid;
      instance.on(event, function() {
        try {
          return _scopedTrigger.apply(this, arguments);
        } catch(exc) {
          console.error(`[componentTrigger] Event "${event}" failed in component "${_compLabel}": `, exc);
        }
      });
    });
  }

  if (options.triggers && options.triggers.mediaTriggers) {
    _.each(options.triggers.mediaTriggers, (trigger, event) => {
      const scope = {
        component:instance,
        app:instance.app,
        chart:instance.chart,
        dataSource:instance.getDataSource(),
      };
      Object.defineProperty(scope, 'data', {
        get() { return instance.data; },
        enumerable: true
      });
      Object.defineProperty(scope, 'fn', {
        get() { return instance.fn; },
        enumerable: true
      });
      const _scopedTrigger = rescopeFunction(trigger, scope, instance);
      const _compName = (instance.options && instance.options.chartName) || instance.args.name || '';
      const _compCid = instance.args.cid || '';
      const _compLabel = _compName ? (_compCid ? `${_compName} [${_compCid}]` : _compName) : _compCid;
      instance.on(event, function() {
        try {
          return _scopedTrigger.apply(this, arguments);
        } catch(exc) {
          console.error(`[mediaTrigger] Event "${event}" failed in component "${_compLabel}": `, exc);
        }
      });
    });
  }

  if (options.triggers && options.triggers.canvasTriggers) {
    _.each(options.triggers.canvasTriggers, (trigger, event) => {
      const scope = {
        component:instance,
        app:instance.app,
        chart:instance.chart,
        dataSource:instance.getDataSource(),
      };
      Object.defineProperty(scope, 'data', {
        get() { return instance.data; },
        enumerable: true
      });
      Object.defineProperty(scope, 'fn', {
        get() { return instance.fn; },
        enumerable: true
      });
      const _scopedTrigger = rescopeFunction(trigger, scope, instance);
      const _compName = (instance.options && instance.options.chartName) || instance.args.name || '';
      const _compCid = instance.args.cid || '';
      const _compLabel = _compName ? (_compCid ? `${_compName} [${_compCid}]` : _compName) : _compCid;
      instance.chart.on(event, function() {
        try {
          return _scopedTrigger.apply(this, arguments);
        } catch(exc) {
          console.error(`[canvasTrigger] Event "${event}" failed in component "${_compLabel}": `, exc);
        }
      });
    });
  }

  if(options.renderCanvas=='never'){
    instance.suspendCanvasRendering = true;
  }

  if(options.renderControls=='never'){
    instance.suspendControlsRendering = true;
  }

  instance.audio = new AudioAPI(instance,'options.audio');
  instance.recorder = new RecorderAPI(instance,'options.recorder');
  instance.transcriber = new TranscriberAPI(instance,'options.transcriber');
  instance.enable();
  instance.resize();
  instance.spinner = new Spinner(instance);
  instance.timeline = new Timeline(instance);
  instance.minimap = new Minimap(instance);
  instance.dropBoxComponent = new DropBoxComponent(instance);
  instance.once('render', () => {

    instance.fire('ready');
    if(instance.timer._config.autostart=='onComponentReady'){
      instance.timer.start();
    }

    if (instance.datasources.empty){
      instance.fire('init');
      if(instance.timer._config.autostart=='onDataReady'){
        instance.timer.start();
      }
    }

  });

  if(instance.timer._config.autostart=='onDataReady'){
    instance.once('loaddata',()=>{
      instance.once('render',()=>{
        instance.timer.start();
      });
    });
  }  

  instance.on(['beforereload','beforerender','ready','init','reload','render','beforeRenderCanvas','renderCanvas', 'resize','beforeresize'],
    instance._logRender);

  return instance;
}

function dropBoxList(args, path){  
  return listDropbox({path,...args});
}

function dropBoxDownload(args, path, name){  
  return downloadDropbox({...args,path,name});
}

function dropBoxGetFileUrl(args, path, name){  
  return getFileUrlDropBox({...args,path,name});
}

function dropBoxDelete(args, path, name){  
  return deleteDropbox({...args,path,name});
}

function dropBoxUpload(args, path, file, onProgress){  
  return uploadDropbox({...args,path,file, onProgress});
}

function dropBoxMput(args, path, file, codec, partId, close, onProgress){  
  return mputDropbox({...args,path,file, codec, partId, close, onProgress});
}

function loadChart(args) {
  args.log('loadChart', args);
  return new Promise(function(resolve, reject) {
    if (args.options) {
      args.log('loadChart - options found, create instance..');
      resolve(createInstance(args, args.options, args.datasource));
    } else {
      const {auth,token} = args;      
      let url;
      if (args.preview) {
        args.log('loadChart - preview mode, get draft options..');
        url = `${args.url}/ds/TSPACE.qlt$Quilt/fn/chartGetOptionsFrom?cid=${
          args.fullCid
        }&args=&userDataspace=&isPublic=false&responseFormat=string&responseMimeType=application/json`;
      } else {
        args.log('loadChart - get published options..');
        url = `${args.url}/chart/options/${args.fullCid}?args={}`;
      }

      http(url, auth, token, args.delay)
        .then((resp) => {
          var options;
          var datasources = {empty:true};
          for (var i = 0; i < resp.length; i++) {
            var row = resp[i];
            if (row.Key == 'options') {
              options = funJSON.parse(row.Value);
              options.$src = row.Value;
              // console.log('options loaded:',options);
            } else if (row.Key == 'datasources' && row.Value) {
              datasources = funJSON.parse(row.Value);
              if(!datasources.function){
                datasources.empty = true;
              }
              // datasources.dataspace = datasources.dataspace._.replace(/[\[\]]/g,"");
            }
          }

          if (!options) {
            args.log('Failed to get chart, empty options', resp);
            reject('Failed to get chart, empty options');
          }

          resolve(createInstance(args, options, datasources));
        })
        ['catch']((err) => {
          args.log('loadChart - Failed to get chart, connection error', err);
          reject(
            err.message || (_.isString(err) && err) || 'Failed to get chart, connection error'
          );
        });
    }
  });
}

function preserveOptions(options, instance) {
  const currentOptions = instance.chart.getOption();

  if (currentOptions && currentOptions.dataZoom) {
    _.each(options.dataZoom, function(dz, i) {
      if (currentOptions.dataZoom[i]) {
        if (currentOptions.dataZoom[i].start !== undefined) {
          dz.start = currentOptions.dataZoom[i].start;
        }

        if (currentOptions.dataZoom[i].end !== undefined) {
          dz.end = currentOptions.dataZoom[i].end;
        }

        if (currentOptions.dataZoom[i].startValue !== undefined) {
          dz.startValue = currentOptions.dataZoom[i].startValue;
        }

        if (currentOptions.dataZoom[i].endValue !== undefined) {
          dz.endValue = currentOptions.dataZoom[i].endValue;
        }
      }
    });
  }

  return options;
}

function preProcessOptions(options, instance) {
  instance.fire('beforepreprocessoptions', options);
  _.eachDeep(
    options.controls,
    function(control, i, parent, ctx) {
      if (control && control.handler) {
        console.warn(
          `deprecated "handler" option used at
            controls${ctx.path}. Use "trigger" instead.`
        );
        if (control && !control.trigger) {
          control.trigger = control.handler;
        }
      }
    },
    { childrenPath: 'controls' }
  );  

  if (options.toolbox && options.toolbox.feature) {
    if (options.toolbox.feature.reloadData && _.isObject(options.toolbox.feature.reloadData)) {
      options.toolbox.feature.myReloadData = _.merge(
        {
          title: 'Refresh',
          icon:
            'path://M19,12H22.32L17.37,16.95L12.42,12H16.97C17,10.46 16.42,8.93 15.24,7.75C12.9,5.41 9.1,5.41 6.76,7.75C4.42,10.09 4.42,13.9 6.76,16.24C8.6,18.08 11.36,18.47 13.58,17.41L15.05,18.88C12,20.69 8,20.29 5.34,17.65C2.22,14.53 2.23,9.47 5.35,6.35C8.5,3.22 13.53,3.21 16.66,6.34C18.22,7.9 19,9.95 19,12Z',
          iconStyle: {
            color: '#777',
            borderWidth: 0,
            emphasis: {
              color: 'teal',
            },
          },
        },
        options.toolbox.feature.reloadData
      );
      options.toolbox.feature.myReloadData.onclick = function() {
        instance.reload();
      };

      delete options.toolbox.feature.reloadData;
    }
  }

  if (!options.xAxis) {
    options.xAxis = [];
  }

  if (options.xAxis && !Array.isArray(options.xAxis)) {
    options.xAxis = [options.xAxis];
  }

  if(!options.xAxis.length) {options.xAxis.push({});}

  _.each(options.xAxis, (x, i) => {
    if (x.id === undefined) {
      x.id = `xAxis-${i}`;
    }

    if(x.gridIndex === undefined){
      x.gridIndex = 0;
    }

    if(options.grid && options.grid[x.gridIndex] && options.grid[x.gridIndex].xAxis){
      _.merge(x,options.grid[x.gridIndex].xAxis)
    }

  });

  if (!options.yAxis) {
    options.yAxis = [];
  }

  if (options.yAxis && !Array.isArray(options.yAxis)) {
    options.yAxis = [options.yAxis];
  }

  if(!options.yAxis.length) {options.yAxis.push({});}

  _.each(options.yAxis, (y, i) => {
    if (y.id === undefined) {
      y.id = `yAxis-${i}`;
    }

    if(y.gridIndex === undefined){
      y.gridIndex = 0;
    }

    if(options.grid && options.grid[y.gridIndex] && options.grid[y.gridIndex].yAxis){
      _.merge(y,options.grid[y.gridIndex].yAxis)
    }
  });

  if (options && options.series) {
    const customFields = recharts.getDataElementFields(instance.originalOptions);

    _.each(options.series, function(serie,i) {
            
      if (serie.xAxisIndex === undefined) {
        serie.xAxisIndex = 0;
      }

      if (serie.yAxisIndex === undefined) {
        serie.yAxisIndex = 0;
      }

      const xAxis = options.xAxis[serie.xAxisIndex];
      const yAxis = options.yAxis[serie.yAxisIndex];

      const isXYVN = recharts.dataElementSupportsXYVN[serie.type];
      const isXY =
        isXYVN && (!xAxis || xAxis.type != 'category') && (!yAxis || yAxis.type != 'category');

      // console.log({ isXYVN });

      if (isXYVN) {
        if(serie.data){
          serie.data.forEach((element, i) => {
            var value = element.value;
            if (!_.isObject(element)) {
              value = element;
              element = serie.data[i] = {};
            }

            if (isXY) {
              if (element.xCoordinate === undefined) {
                element.xCoordinate = i;
              }

              if (element.yCoordinate === undefined) {
                element.yCoordinate = value;
              }

              if(!Array.isArray(element.value)){
                element.value = [
                  element.xCoordinate,
                  element.yCoordinate,
                  value,
                  element.name || '',
                  element.itemCategory||'',
                ];
              }
            } else if(!Array.isArray(element.value)){
              if (yAxis && yAxis.type === 'category') {
                element.value = [value, i, element.name || '', element.itemCategory||''];
              } else {
                element.value = [i, value, element.name || '', element.itemCategory||''];
              }
            }

            customFields.forEach((cf) => {
              element.value.push(_.get(element, cf));
            });
          });          
        }

        if (options.visualMap) {
          let sysFields;
          if (isXY) {
            sysFields = Object.keys(recharts.dataElementSysFields);
          } else {
            if (yAxis && yAxis.type === 'category') {
              sysFields = ['value', 'index', 'name', 'itemCategory'];
            } else {
              sysFields = ['index', 'value', 'name', 'itemCategory'];
            }
          }

          const fields = [...sysFields, ...customFields];

          options.visualMap.forEach((vm) => {
            if (vm.itemCategory!==undefined) {
              vm.dimension = fields.indexOf(vm.itemCategory);
              if (vm.dimension == -1) {
                vm.dimension=fields.indexOf('itemCategory');
              }
            }else{
              vm.dimension=fields.indexOf('itemCategory');
            }
          });
        }
      }

      if(recharts.hideXYAxis[serie.type]){
        xAxis.show=false;
        yAxis.show=false;
      }

      if ((serie.type == 'tree' || serie.type == 'treemap') && serie.data) {
        var srcData = serie.data;
        var index = {};
        serie.data = [];
        serie.dataIndex = index;
        _.each(srcData, function(node) {
          index[node.name] = node;
          if (node.parentName === undefined || node.parentName === null) {
            serie.data.push(node);
          } else {
            var parent = index[node.parentName] || _.find(srcData, ['name', node.parentName]);
            if (!parent) {
              serie.data.push(node);
              return;
            } else {
              if (!index[node.parentName]) {
                index[node.parentName] = parent;
              }
            }

            if (!parent.children) {
              parent.children = [];
            }

            parent.children.push(node);
          }
        });
      }

      if (serie.type == 'sankey' && serie.data) {
        var nodeMap = serie.data.reduce((res, node) => {
          res[node.name] = node;
          node.inValue = 0;
          node.outValue = 0;
          if (node.value) {
            node.value = node.value * 1;
          }

          return res;
        }, {});
        serie.links.forEach((l) => {
          if (nodeMap[l.source]) {
            nodeMap[l.source].outValue += l.value;
          } else {
            debug(`link source "${l.source}" not found in node list`, l);
          }

          if (nodeMap[l.target]) {
            nodeMap[l.target].inValue += l.value;
          } else {
            debug(`link target "${l.target}" not found in node list`, l);
          }
        });
        serie.data.forEach((node) => {
          if (node.inValue && node.inValue !== node.value) {
            debug(`node "${node.name}" inValue and value mismatch`, node);
          }

          if (node.outValue && node.outValue !== node.value) {
            debug(`node "${node.name}" outValue and value mismatch`, node);
          }
        });
      }

      if (serie.type == 'graph' && serie.data && typeof serie.symbolSize == 'function') {
        serie.data.forEach(node => {
          if(node.symbolSize===undefined){
            node.symbolSize = serie.symbolSize(node.value, node);
          }
        });
        delete serie.symbolSize;
      }

      if (serie.type == 'graph' && serie.data && typeof serie.symbol == 'function') {
        serie.data.forEach(node => {
          if(node.symbol===undefined){
            node.symbol = serie.symbol(node.value, node);
          }
        });
        delete serie.symbol;
      }

      if (serie.type == 'graph' && serie.data && typeof serie.symbolRotate == 'function') {
        serie.data.forEach(node => {
          if(node.symbolRotate===undefined){
            node.symbolRotate = serie.symbolRotate(node.value, node);
          }
        });
        delete serie.symbolRotate;
      }
    });
  }

  _.each(options.dataZoom, (dz, i) => {
    if (dz.id === undefined) {
      dz.id = 'dataZoom-' + i;
    }

    if (dz.xAxisIndex === undefined) {
      //dz.xAxisIndex = [];
    } else if (!Array.isArray(dz.xAxisIndex)) {
      dz.xAxisIndex = [dz.xAxisIndex];
    }

    if (dz.yAxisIndex === undefined) {
      //dz.yAxisIndex = [];
    } else if (!Array.isArray(dz.yAxisIndex)) {
      dz.yAxisIndex = [dz.yAxisIndex];
    }
  });

  // if (options.graphic) {
  //   options.graphic = [options.graphic];
  // }

  _.eachDeep(
    options,
    function(value, key, parent, ctx) {
      if(key=='_scope'&&_.isFunction(parent)) {return false;}

      let path = ctx.path || '';
      let parentKey = ctx.parent && ctx.parent.key;
      let parentPath = ctx.parent && ctx.parent.path;
      if (_.isFunction(value) && !value._scope) {
        var meta = {
          key: key,
          path: path,
          parent: parent,
          parentKey: parentKey,
          parentPath: parentPath,
          //args:getArgNames(value),
        };
        
        
        const scope = {
          component:instance,
          app:instance.app,
          chart:instance.chart,
          dataSource:instance.getDataSource(),
          meta,
        };
        Object.defineProperty(scope, 'data', {
          get() { return instance.data; },
          enumerable: true
        });
        Object.defineProperty(scope, 'fn', {
          get() { return instance.fn; },
          enumerable: true
        });
        parent[key] = rescopeFunction(value, scope);
      }
    },
    { includeRoot: false }
  );

  instance.methods = {};
  _.eachDeep(
    options.vars,
    function(value, key, parent, ctx) {
      let path = ctx.path || '';
      if (_.isFunction(value)) {
        _.set(instance.methods,path,value);
        return false;        
      }
    },
    { includeRoot: false }
  );

  instance.fn = instance.methods;

  instance.fire('preprocessoptions', options);
  return options;
}

function callDatasourceFunction(instance, datasourceParameters) {
  if (instance.destroyed) {
    return Promise.resolve([]);
  }

  var args = instance.args;
  instance.log('callDatasourceFunction ' + JSON.stringify(datasourceParameters));
  instance.fire('beforedatasource', datasourceParameters);
  return new Promise(function(resolve, reject) {
    let url;
    const {auth,token} = args;
    if (args.preview) {
      instance.log('preview mode enabled');
      if (args.datasource) {
        instance.log('using passed datasource');
        url = `${args.url}/ds/TSPACE.qlt$Quilt/fn/chartTestDataFrom?nodeName=${encodeURIComponent(
          args.datasource.node
        )}&dataspaceName=${encodeURIComponent(
          args.datasource.dataspace
        )}&functionName=${encodeURIComponent(args.datasource.function.name)}&functionFormat=${
          args.datasource.function.format
        }&args=${encodeURIComponent(
          JSON.stringify(args.datasource.function.arguments.values)
        )}&argsOver=${encodeURIComponent(
          JSON.stringify(datasourceParameters)
        )}&responseFormat=string&responseMimeType=application/json`;/*${
          auth ? '&' + auth : '&x-session-token=' + token
        }`;*/
      } else {
        instance.log('using saved draft datasource');
        url = `${args.url}/ds/TSPACE.qlt$Quilt/fn/chartGetDataFrom?cid=${
          args.fullCid
        }&args=${encodeURIComponent(
          JSON.stringify(datasourceParameters)
        )}&userDataspace=&isPublic=false&responseFormat=string&responseMimeType=application/json`;/*${
          auth ? '&' + auth : '&x-session-token=' + token
        }`;*/
      }
    } else {
      instance.log('using published datasource');
      url = `${args.url}/chart/data/${args.fullCid}?args=${encodeURIComponent(
        JSON.stringify(datasourceParameters)
      )}`;//&${auth ? auth : 'x-session-token=' + token}`;
    }

    http(url, auth,token, args.delay)
      .then((data) => {
        resolve(parseRestResult(data));
        instance.fire('datasource', data);
      })
      ['catch']((err) => {
        reject(err);
        instance.fire('faildatasource', err);
      });
  });
}

function parseRestResult(data) {
  if (data.json !== undefined) {
    return data.json;
  }

  if (data.rowset) {
    return { RowSet: { rows: data.rowset } };
  }
}

function toggleEnabled(instance, enabled, options) {
  options = _.merge(
    {
      text: '',
      textColor: '#CCCCCC',
      maskColor: '#000000',
      maskOpacity: 0.7,
      blur: '2px',
    },
    options || {}
  );

  if (!instance.mask) {
    instance.mask = {};
  }

  if (!instance.mask.el || !document.body.contains(instance.mask.el)) {
    instance.mask.el = document.createElement('div');
    instance.mask.el.classList.add('disabled-mask');
    instance.mask.el.innerHTML = '<div class="disabled-label"></div>';
    instance.args.element.appendChild(instance.mask.el);
  }

  var style = _.merge({}, getDefaultStyle(), {
    position: 'absolute',
    display: 'block',
    zIndex: 100500,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: options.maskColor,
    opacity: enabled ? 0 : options.maskOpacity,
    pointerEvents: enabled ? 'none' : 'auto',
    color: options.labelColor,
    transitionProperty: 'opacity',
    transitionDuration: '0.5s',
    transitionTimingFunction: 'ease',
    transitionDelay: '0s',
  });

  var labelEl = instance.mask.el.getElementsByClassName('disabled-label')[0];
  labelEl.innerHTML = options.text;
  var labelStyle = _.merge({}, getDefaultStyle(), {
    position: 'absolute',
    display: 'block',
    top: '50%',
    right: 0,
    left: 0,
    textAlign: 'center',
    color: options.labelColor,
    transform: 'translate3d(0,-50%,0)',
  });
  updateStyle(labelEl, labelStyle, instance.mask.labelStyle);
  instance.mask.labelStyle = labelStyle;
  updateStyle(instance.mask.el, style, instance.mask.style);
  instance.mask.style = style;
  instance.args.element.style.filter = 'blur(' + (enabled ? '0px' : options.blur) + ')';
  instance.fire(enabled ? 'enable' : 'disable', options);
}

function render(instance, data) {
  if (instance.destroyed) {
    return Promise.resolve(instance);
  }

  if (instance.suspended) {
    instance.suspendedRender = () => {
      delete instance.suspendedRender;
      return render(instance, data);
    };

    return Promise.resolve(instance);
  }

  // console.log('render(instance,data)', instance, data);
  instance.fire('beforerender', data);
  if (data !== undefined) {
    instance.data = data;
  }


  instance.options = bindData(instance, data);
  

  if (instance.chart) {
    //instance.chart.clear();
    if (!_.isEmpty(instance.patchOptions)) {
      instance.options = _.merge(instance.options, instance.patchOptions);
    }

    let processed = bindDomainVars(instance.options, instance);
    processed = linkData(instance.options, instance);
    processed = linkIcons(processed, instance);
    processed = preProcessOptions(processed, instance);
    processed = preserveOptions(processed, instance);

    if(!instance.suspendCanvasRendering){
      instance.fire('beforeRenderCanvas',instance.options);
      instance.chart.setOption(processed);          
      instance.fire('renderCanvas',instance.options);
    }

    if (instance.options.controls&&!instance.suspendControlsRendering) {
      renderControls(instance);
    }

    // _.eachDeep(instance.options, (value, key, parent, ctx) => {
    //   if (ctx.isCircular) {
    //     console.log(
    //       'Circular reference to '+ctx.circularParent.path+' skipped at ' + ctx.path
    //     );
    //     return false; // explicit `false` will skip children of current value
    //   }
    // //do your job here
    // },{ checkCircular: true });
  }

  instance.updateDatasourceParameters();

  if (instance.options.backgroundColor) {
    instance.args.element.style.backgroundColor = instance.options.backgroundColor;
  } else if (instance.args.element.style.getPropertyPriority('background-color') !== 'important') {
    instance.args.element.style.backgroundColor = '';
  }

  _.defer(function() {
    instance.fire('render', instance.options);
    if(data){
      instance.fire('init', instance, data);
    }
  });
  return Promise.resolve(instance);
}

function bindDomainVars(options, instance){
  instance.fire('beforebinddomainvars', options);
  if(options.$domainVars && options.bindings && options.bindings.domainvars){
    _.each(options.bindings.domainvars, (name,path)=>{
      if(options.$domainVars[name]!==undefined){
        _.set(options,path,options.$domainVars[name]);
      }
    });
  }

  instance.fire('binddomainvars', options);
}

function bindData(instance, records, re) {
  const sharedKeys = {};
  instance.dataCount = 1;
  if (
    records === undefined &&
    instance.boundOptions === undefined &&
    instance.datasources.cache != undefined
  ) {
    records = cloneDeepWithFunctions(instance.datasources.cache);
  }

  if (
    records === undefined &&
    instance.hasExtBinding || (
      instance.boundOptions &&
      _.some(instance.boundOptions.sharedKeys, (v, p) => instance.getVariable(p) !== v)
      )
  ) {
    records = instance.data;
  }

  if (records != undefined  || instance.hasExtBinding||  instance.boundOptions === undefined) {
    var options = re ?
      instance.chart.getOption() : (
        (records != undefined || instance.boundOptions === undefined) ? 
          cloneDeepWithFunctions(instance.originalOptions) : 
          cloneDeepWithFunctions(instance.boundOptions));
    instance.fire('beforebinddata', records, re, options);
    _.each(instance.bindings, function(optPath) {
      bind(options, optPath, records, instance, sharedKeys)
    });
    instance.boundOptions = _.cloneDeepWithFunctions(options);
    instance.boundOptions.sharedKeys = sharedKeys;
  } else if (instance.boundOptions !== undefined) {
    // console.log('cached bound data', instance.boundOptions);
    return _.cloneDeepWithFunctions(instance.boundOptions);
  }

  // console.log('bound data', options);
  instance.fire('binddata', records, re, options);
  return options;
}

function bind(options, optPath, recs, instance, sharedKeys){

  // if(instance.frozenOptions.some(f=>optPath.startsWith(f))) {
  //   return;
  // }

  optPath = _.toPath(optPath);
  var boundOption = _.cloneDeepWithFunctions(_.get(instance.originalOptions, optPath));

  var binding = boundOption.binding || boundOption[0];

  if (!binding) {
    instance.warn('binding not found @' + optPath, boundOption);
    return;
  }

  if(instance._inited && binding.cached){
    if(!instance.boundOptions){
      _.unset(options, optPath);      
    }else{
      _.set(options, optPath,_.get(instance.boundOptions, optPath));      
    }

    return;
  }

  if(binding.extType){
    recs = instance.extData[binding.extType];
    if(recs && binding.extName){
      let up=0;
      while(binding.extName[up]===':'){
        up++;            
      }

      let parentPath = [
        ..._.take(optPath,optPath.length-up),
        ..._.toPath(binding.extName.replace(/:+/,''))
        ];
      const extName = _.get(instance.originalOptions,parentPath);
      recs = recs[extName];
    }
  }

  // var path = _.replace(binding.editedPath || binding.path, '[*]', '');
  var fields = binding.fields || null;
  if(!_.isEmpty(fields)){
    fields.$id = '$id';
  }
  
  var pickedPaths = binding.pickedPaths || {};
  var sharedIndex = binding.sharedIndex || {};
  if (pickedPaths) {
    const bindingPath = _.toPath(binding.path);
    let testPath = '';
    const evaluatedPath = [];
    _.each(bindingPath, (step) => {
      let varName = sharedIndex[testPath] && sharedIndex[testPath][step];
      if (varName === undefined && step.startsWith('{') && step.endsWith('}')) {
        varName = step;
      }

      const sv = varName && instance.getVariable(varName.substring(1, varName.length - 1));

      if (sv !== undefined) {
        sharedKeys[varName.substring(1, varName.length - 1)] = sv;
        const ep = _.pathToString(evaluatedPath);

        if (!pickedPaths[ep]) {
          pickedPaths[ep] = [];
        }

        pickedPaths[ep].push(sv);
        evaluatedPath.push(sv);
      } else {
        evaluatedPath.push(step);
      }

      testPath = _.pathToString([step], testPath);
    });

    binding.path = _.pathToString(evaluatedPath);
  }

  var model = boundOption[1];

  var cutPath = binding.path;
  var data = _.isObject(recs) ? _.get(recs, cutPath) : recs;
  if (_.isArray(data) && data.length > instance.dataCount) {
    instance.dataCount = data.length;
  }

  if (data === undefined && _.isObject(recs)) {
    _.eachRight(pickedPaths, function(keys, path) {
      if (_.startsWith(cutPath, path)) {
        var cutKey = _.find(keys, function(pk) {
          return cutPath == _.pathToString([pk, 'key'], path);
        });
        if (cutKey) {
          data = cutKey;
          return false;
        }

        cutKey = _.find(keys, function(pk) {
          return _.startsWith(cutPath, _.pathToString([pk, 'element'], path));
        });
        if (cutKey) {
          cutPath = cutPath.replace(
            new RegExp('^' + _.escapeRegExp(_.pathToString([cutKey, 'element'], path))),
            _.pathToString([cutKey], path)
          );
          return;
        }

        cutKey = _.find(keys, function(pk) {
          return _.startsWith(cutPath, _.pathToString([pk, 'value'], path));
        });
        if (cutKey) {
          cutPath = cutPath.replace(
            new RegExp('^' + _.escapeRegExp(_.pathToString([cutKey, 'value'], path))),
            _.pathToString([cutKey], path)
          );
          return;
        }
      }
    });
    // if (_.endsWith(binding.path, '.element')) {
    //   cutPath = cutPath.substr(0, cutPath.length - 8);
    // } else if (_.endsWith(binding.path, '.value')) {
    //   cutPath = cutPath.substr(0, cutPath.length - 6);
    // }

    const tryPick = _.get(recs, cutPath);
    data = tryPick !== undefined ? tryPick : data || recs;
  }

  var optionsData = data;
  // var pickedKeys;
  // instance.log("data extracted from ",binding,data,recs);
  var dataPath = binding.path;
  if (!_.isEmpty(fields)) {
    if (!_.isArray(data)) {
      // pickedKeys =
      //   pickedPaths[binding.path] || pickedPaths[binding.path + '.element'];
      dataPath += '.element';
      const arr = [];
      for (const key in data) {
        const value = data[key];
        if (!_.isObject(value)) {
          arr.push({ key: key, value: value });
        } else {
          arr.push({ key: key, element: value });
        }
      }

      data = arr;
    } else {
      // pickedKeys = pickedPaths[binding.path + '[0]'];
      dataPath += '[0]';
    }

    optionsData = [];
    for (var i = 0; i < data.length; i++) {
      optionsData[i] = applyFieldMapping(model, data[i], fields, pickedPaths, dataPath);
    }

    // instance.log("binding applied",data,"->",optionsData);
  }

  if (optionsData === undefined) {
    optionsData = boundOption.staticValue;
  }

  // Backward-compat: legacy specs placed formatter inside the bound option
  // itself (`binding.formatter` or `formatter` on the option). v4.46.26 moved
  // formatters to control level (textFormatter/HTMLFormatter/urlFormatter/…)
  // applied in control.js addApi. Modern specs don't carry these legacy keys,
  // so this branch is a no-op for them. If a spec has BOTH, both will fire —
  // author should pick one (prefer the control-level one).
  var formatter = _.get(boundOption, 'binding.formatter') || _.get(boundOption, 'formatter');

  if (formatter && _.isFunction(formatter)) {
    // Only execute formatter if we have actual data from the binding
    // Skip execution when data hasn't loaded yet (empty string, undefined, or null)
    const hasBindingData = binding && data !== undefined && data !== null && data !== '';
    const hasStaticValue = boundOption.staticValue !== undefined && boundOption.staticValue !== null;

    if (hasBindingData || (!binding && hasStaticValue)) {
      try {
        const scope = {
          component: instance,
          app: instance.app,
          chart: instance.chart,
          dataSource: instance.getDataSource(),
        };
        Object.defineProperty(scope, 'data', {
          get() { return instance.data; },
          enumerable: true
        });
        Object.defineProperty(scope, 'fn', {
          get() { return instance.fn; },
          enumerable: true
        });

        const scopedFormatter = rescopeFunction(formatter, scope, instance);
        optionsData = scopedFormatter(optionsData, instance);
      } catch (error) {
        console.error('[legacy binding.formatter] failed at', optPath, error);
      }
    }
  }

  _.set(options, optPath, optionsData);
}

function applyFieldMapping(model, source, fields, pickedPaths, dataPath) {
  // var res =
  //   (model && _.cloneDeepWithFunctions(model)) ||
  //   (_.isArray(source) ? [] : _.isObject(source) ? {} : source);
  // delete model.type;
  model = model || source;
  var res = _.isArray(model) ? [] : _.isObject(model) ? {} : source;

  _.each(fields, function(srcPath, dstPath) {
    const fullPath = _.pathToString([], dataPath, srcPath);
    const pickedPath = _.reduce(
      pickedPaths,
      (res, keys, path) => (_.startsWith(fullPath, path) && path.length > res.length ? path : res),
      ''
    );
    const pickedKeys = pickedPaths[pickedPath];
    //srcPath = _.toPath(srcPath);
    if (!_.isArray(source) && pickedKeys) {
      var pickedKey = _.find(pickedKeys, (pk) => {
        const fullSrcPath = _.pathToString([], dataPath, srcPath);
        const fullPickedPath = _.pathToString([pk], pickedPath);
        // console.log(fullSrcPath, ' vs ', fullPickedPath);
        return _.startsWith(fullSrcPath, fullPickedPath);
      });
      if (pickedKey !== undefined) {
        srcPath = _.toPath(srcPath);
        if (srcPath[srcPath.length - 1] == 'key' && srcPath[srcPath.length - 2] == pickedKey) {
          if (dstPath) {
            _.set(res, dstPath, pickedKey);
          } else {
            res = pickedKey;
          }

          return;
        }

        if (srcPath[srcPath.length - 1] == 'value' && srcPath[srcPath.length - 2] == pickedKey) {
          srcPath = srcPath.slice(0, srcPath.length - 1);
        } else if (srcPath[0] == pickedKey && srcPath[1] == 'element') {
          srcPath = [pickedKey].concat(srcPath.slice(2));
        } else if (srcPath[0] == 'element' && srcPath[2] == 'element' && srcPath[1] == pickedKey) {
          srcPath = ['element', pickedKey].concat(srcPath.slice(3));
        }
      }
    }

    if (dstPath) {
      _.set(res, dstPath, srcPath.length ? _.get(source, srcPath) : source);
    } else {
      res = srcPath.length ? _.get(source, srcPath) : source;
    }
  });
  return res;
}

// Resolve a single variableLink into the options tree. Extracted from
// linkData so setVariable's auto-sync path can re-link the affected option
// paths individually without walking the whole instance.links map. Pushes
// any work that needs to run after the synchronous pass into `deferred`
// (same contract linkData had).
function linkOneVariable(optPath, link, options, instance, deferred) {
  const variable = link.variable;
  if (!variable) {
    instance.warn('variable not found @' + optPath, link);
    return;
  }

  const value = _.get(options.vars, variable.path);
  if (value === undefined) {
    console.error(
      `Broken link to shared variable "${variable.path}" from option "${optPath}". Falling back to static value...`
    );
    _.set(options, optPath, link.staticValue);
    return;
  }

  if (_.isFunction(value)) {
    if (_.startsWith(value.toString(), 'function($rechartsVarArgs')) {
      deferred.push(() => {
        _.set(options, optPath, value(variable.arg, options.vars, link.meta, instance));
      });
    } else if (link.action == 'execute') {
      deferred.push(() => {
        const rescopeScope = {
          component: instance,
          app: instance.app,
          chart: instance.chart,
          dataSource: instance.getDataSource(),
          variable,
          link,
          meta: link.meta,
          staticValue: link.staticValue,
        };
        Object.defineProperty(rescopeScope, 'data', {
          get() { return instance.data; },
          enumerable: true
        });
        Object.defineProperty(rescopeScope, 'fn', {
          get() { return instance.fn; },
          enumerable: true
        });

        const executeScope = {
          component: instance,
          app: instance.app,
          chart: instance.chart,
          dataSource: instance.getDataSource(),
          variable,
          link,
          meta: link.meta,
          staticValue: link.staticValue,
        };
        Object.defineProperty(executeScope, 'data', {
          get() { return instance.data; },
          enumerable: true
        });
        Object.defineProperty(executeScope, 'fn', {
          get() { return instance.fn; },
          enumerable: true
        });

        _.set(options, optPath, executeFunction(rescopeFunction(value, rescopeScope, instance), executeScope, instance));
      });
    } else {
      _.set(options, optPath, value);
    }
  } else {
    _.set(options, optPath, value);
  }
}

// Build (and cache on the instance) a reverse index from variable path →
// list of option paths that bind to it. Used by syncVariable to find the
// minimum set of paths that need re-linking when a single variable changes.
// Cached forever per instance: `instance.links` is built once at init from
// the original options and doesn't mutate during the instance's lifetime.
function getLinksByVar(instance) {
  if (!instance._linksByVar) {
    const byVar = {};
    _.each(instance.links, (link, optPath) => {
      const v = link && link.variable && link.variable.path;
      if (!v) { return; }
      if (!byVar[v]) { byVar[v] = []; }
      byVar[v].push(optPath);
    });
    instance._linksByVar = byVar;
  }
  return instance._linksByVar;
}

// Walk back from any nested option path to the longest prefix registered as
// a control instance. Returns null if the path is outside a control (e.g.
// belongs to series / vars / icons themselves — those are handled by the
// chart's own redraw paths).
function findEnclosingControlPath(optPath, instance) {
  let path = optPath;
  while (path) {
    if (instance.controls && instance.controls[path]) {
      return path;
    }
    const m = path.match(/^(.+?)(\.[^.\[\]]+|\[\d+\])$/);
    if (!m) { break; }
    path = m[1];
  }
  return null;
}

// Auto-sync entry point invoked by setVariable / setVariables. Resolves
// only the variableLinks that bind to `varName`, then re-renders just the
// controls those links live inside — avoiding the full-canvas redraw cost
// (and the unwanted side effects) of `component.render()`.
//
// Edge cases left as full-render fallback for the caller:
//   1. Variables used INSIDE another variable's function body (formulas).
//      We don't trace transitive dependencies — the user can still call
//      component.render() if a derived var needs to recompute.
//   2. Variables consumed by data-binding paths (`${var}` inside a binding
//      path). bindData() needs to re-run for those — not handled here.
function syncVariable(instance, varName) {
  const byVar = getLinksByVar(instance);
  const affectedPaths = byVar[varName];
  if (!affectedPaths || affectedPaths.length === 0) { return; }

  const deferred = [];
  affectedPaths.forEach(optPath => {
    const link = instance.links[optPath];
    if (link) {
      linkOneVariable(optPath, link, instance.options, instance, deferred);
    }
  });
  deferred.forEach(f => { try { f(); } catch (e) { console.warn('deferred variable link failed', e); } });

  const ctrls = new Set();
  affectedPaths.forEach(optPath => {
    const ctrlPath = findEnclosingControlPath(optPath, instance);
    if (ctrlPath) { ctrls.add(ctrlPath); }
  });
  ctrls.forEach(p => {
    try { instance.controls[p].render(); }
    catch (e) { console.warn('Failed to re-render control after setVariable', p, e); }
  });
}

function linkData(options, instance) {
  //console.log('link');
  instance.fire('beforelinkdata', options);
  const deferred = [];
  _.each(instance.links, function(link, optPath) {
    linkOneVariable(optPath, link, options, instance, deferred);
  });

  _.each(deferred, (f) => f());

  // console.log('linked data', options);
  instance.fire('linkdata', options);
  return options;
}

function linkIcons(options, instance) {
  instance.fire('beforelinkicons', options);
  var iconLinks = {};

  _.eachDeep(
    options,
    function(value, key, parent, context) {
      let path = context.path || '';

      if (_.isObject(value) && value.binding && value.binding.type === 'iconLink') {
        iconLinks[path] = {
          ...value.binding,
          staticValue: value.staticValue,
          //meta: { value, key, parent, context },
        };
      }
    },
    { includeRoot: false }
  );

  _.each(iconLinks, function(link, optPath) {
    var name = link.name;
    // if (!name) {
    //   instance.warn('link name not found @' + optPath, link);
    // }

    name += '';

    var value = _.find(options.icons, ['name', name]);
    if (value) {
      _.set(options, optPath, value.url);
    } else {
      console.error(
        `Broken link to library icon "${name}" from option "${optPath}". Falling back to static value...`
      );
      _.set(options, optPath, link.staticValue || '');
    }
  });

  // console.log('linked icons', options);
  instance.fire('linkicons', options);
  return options;
}

recharts.colorDialog = colorDialog;
recharts.layout = layout;

recharts.dataElementSysFields = {
  xCoordinate: true,
  yCoordinate: true,
  value: true,
  name: true,
  itemCategory: true,
};

recharts.dataElementIgnoreFields = {
  emphasis: true,
  itemStyle: true,
  label: true,
  symbol: true,
  symbolKeepAspect: true,
  symbolOffset: true,
  symbolRotate: true,
  symbolSize: true,
  tooltip: true,
};

recharts.dataElementSupportsXYVN = {
  line: true,
  bar: true,
  scatter: true,
  effectScatter: true,
  timeline: true,
};

recharts.hideXYAxis = {
  gauge:true,
  graph:true,
  pie:true,
  singlevalue:true,
  sankey:true,
  ticker:true,
  tree:true,
  treemap:true,
  dropbox:true
}

// recharts.dataElementSupportsVN = {
//   bar: true,
// };
recharts.getDataElementFields = function(options) {
  var fields = [];
  ((options && options.series) || []).forEach((s) => {
    if (s.data && s.data[0]) {
      var model = s.data[0];
      if (model.type == 'binding') {
        model = s.data[1];
      }

      _.eachDeep(model, function(v, k, p, x) {
        if (recharts.dataElementSysFields[x.path] || recharts.dataElementIgnoreFields[x.path]) {
          return false;
        }

        if (x.isLeaf && (v !== 'model' || x.path !== 'type') && !_.isObject(v)) {
          fields.push(x.path);
        }
      });
    }
  });

  fields.sort();

  return fields;
};

recharts.uuid = function(subject) {
  if (subject === undefined) {
    return 'uuid-' + uuid4();
  }

  return 'uuid-' + uuid5(subject, uuid5.URL);
};

recharts.requestQueue = requestQueue;
recharts.fflate = fflate;
recharts.fakeApi = fakeApi;

recharts.stripHtml = (html) => {
  const el = document.createElement('span');
  el.innerHTML = html;
  return el.textContent;
};



// recharts.getArgNames = getArgNames;
// recharts.executeFunction = executeFunction;

